import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { ArtistContact } from 'nfty-common/lib/model/artist.model';
import { useState } from 'react';
import { useCheckbox, useInput } from 'nfty-common/lib/hooks/form.hooks';
import onboarding from '../images/onboarding.png';
import * as Firebase from '../services/firebase.service';

export const OnboardingForm = (() => {
    const [hasSuccess, setHasSuccess] = useState(false);
    const [hasError, setHasError] = useState('');

    const emailInput = useInput('');
    const portfolioInput = useInput('');
    const spamCheckInput = useInput('');
    const acceptCheckbox = useCheckbox(true);
    const aboutSelfInput = useInput('');

    function onSubmit() {
        setHasSuccess(false);
        setHasError('');
        if (canSubmit()) {
            const data: ArtistContact = {
                email: emailInput.value,
                portfolioUrl: portfolioInput.value,
                aboutSelf: aboutSelfInput.value,
                acceptedTerms: acceptCheckbox.isChecked,
                spamCheck: spamCheckInput.value
            };

            Firebase.submitContact(data).then(() => {
                setHasSuccess(true);
            }).catch(() => {
                setHasError('Form submission has errors. Please try again.');
            });
        }
    }

    function canSubmit() {
        return (acceptCheckbox.isChecked && emailInput.value && portfolioInput.value && aboutSelfInput.value && !spamCheckInput.value);
    }

    return (
        <div>
            {hasError && <p className="bg-danger rounded-top m-0 p-2">{hasError}</p>}
            {hasSuccess && <p className="bg-primary rounded-top m-0 p-2">Thank you for reaching out! We will contact you as soon as possible.</p>}
            <div className="d-flex border border-secondary">
                <div className="col-5 flex-grow-1 position-relative overflow-hidden">
                    <div className="position-absolute top-0 left-0 mt-3 z-mid">
                        <div className="bg-white text-115 text-dark py-1 px-3 text-avenir-db">NFTY</div>
                    </div>
                    <img style={{ transform: 'scale(1.3)' }} className="w-100 h-100 img-cover" src={onboarding} alt="Become an artist at NFTY" />
                </div>
                <div className="col-5 flex-grow-1 p-5">
                    <h1 className="text-avenir-re">
                        <span className="text-muted">WELCOME TO </span>NFTY
                </h1>
                    <p className="text-avenir-re text-muted mb-5">Art for the next digital movement</p>
                    <div className="text-start text-light">
                        <div className="mb-3">
                            <label className="ms-1 form-label">Contact Email</label>
                            <input required type="email" className="border-secondary form-control" {...emailInput.bind} />
                        </div>
                        <div className="mb-3">
                            <label className="ms-1 form-label">Main Portfolio URL</label>
                            <input required type="text" className="border-secondary form-control" {...portfolioInput.bind} />
                        </div>
                        <div style={{ height: 0, overflow: 'hidden' }} >
                            <label className="">Catch the bots</label>
                            <input required type="text" className="border-secondary form-control" {...spamCheckInput.bind} />
                        </div>
                        <div className="mb-3">
                            <label className="ms-1 form-label">A few words about yourself</label>
                            <textarea required rows={5} className="form-control border-secondary" {...aboutSelfInput.bind}></textarea>
                        </div>
                        <div className="mb-3 form-check form-check-sm">
                            <input type="checkbox" className="form-check-input" readOnly {...acceptCheckbox.bind} />
                            <label className="form-check-label text-avenir-ul text-115">By submitting this form I consent to be contacted by NFTY. None of my data will be collected or sold.</label>
                        </div>
                        <div className="py-4 text-end">
                            <button type="button" className="btn btn-secondary" disabled={!canSubmit()} onClick={onSubmit}>
                                <FontAwesomeIcon icon="envelope" />
                                <span className="ms-2">Get Started</span>
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
});